export const ConnectIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 12H4C2.89543 12 2 12.8954 2 14V28C2 29.1046 2.89543 30 4 30H18C19.1046 30 20 29.1046 20 28V24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M12 8V4C12 2.89543 12.8954 2 14 2H28C29.1046 2 30 2.89543 30 4V18C30 19.1046 29.1046 20 28 20H24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="10" cy="10" r="3" stroke="currentColor" strokeWidth="2" />
    <circle cx="22" cy="22" r="3" stroke="currentColor" strokeWidth="2" />
    <path
      d="M12.5 11.5L19.5 20.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ChartIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 28H28"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M6 24V16C6 15.4477 6.44772 15 7 15H11C11.5523 15 12 15.4477 12 16V24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M13 24V10C13 9.44772 13.4477 9 14 9H18C18.5523 9 19 9.44772 19 10V24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M20 24V6C20 5.44772 20.4477 5 21 5H25C25.5523 5 26 5.44772 26 6V24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="9" cy="13" r="1.5" fill="currentColor" />
    <circle cx="16" cy="7" r="1.5" fill="currentColor" />
    <circle cx="23" cy="3" r="1.5" fill="currentColor" />
  </svg>
);

export const AutomateIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="3"
      y="5"
      width="26"
      height="22"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M3 11H29"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="7" cy="8" r="1" fill="currentColor" />
    <circle cx="11" cy="8" r="1" fill="currentColor" />
    <circle cx="15" cy="8" r="1" fill="currentColor" />
    <path
      d="M9 17L13 21L23 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
